import React from "react";
import PropTypes from "prop-types";

import { useFormatMessage } from "../../../intl/intlHooks";
import { useUsers } from "../../../user/UserContext";
import { userMessages } from "../../../user/userMessages";
import { isObjectEmpty } from "../../../utils/sharedFunctions";
import SSOLoggedIn from "./SSOLoggedIn";
import SSOTabs from "./SSOTabs";

const LoginOptionsTab = ({ children }) => {
    const formatMessage = useFormatMessage();
    const { userData, fetching } = useUsers();
    return (
        <div className="checkout-container">
            {fetching && <span className="user-login-status__loading">{formatMessage(userMessages.userLoading)}</span>}
            {!isObjectEmpty(userData) && !fetching ? (
                <SSOLoggedIn firstName={userData.firstName}>{children}</SSOLoggedIn>
            ) : (
                <SSOTabs>{children}</SSOTabs>
            )}
        </div>
    );
};

LoginOptionsTab.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

export default LoginOptionsTab;
